export const getCreatorsAccordionTitle = (tabTitles: string[]): string => {
    if (tabTitles.length === 0) {
        return '';
    }

    if (tabTitles.length === 1) {
        return tabTitles[0];
    }

    if (tabTitles.length === 2) {
        return `${tabTitles[0]} & ${tabTitles[1]}`;
    }

    return `${tabTitles.slice(0, -1).join(', ')} & ${tabTitles[tabTitles.length - 1]}`;
};
